export function inViewCallback(entries) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('spv-inview--visible');
        }
        else {
        }
    });
}
//# sourceMappingURL=inviewCallback.js.map